import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useData } from "@/context/DataContext";
import { recargarPlanes } from "@/lib/ocio";
import { PersonaPlan } from "@/components/ocio/PersonaPlan";
import { camposGasto } from "@/components/gastos/PorPersona";

const asocDe = (g) => (!g ? "" : g.pet_id ? `pet_id:${g.pet_id}` : g.vivienda_id ? `vivienda_id:${g.vivienda_id}` : g.vehiculo_id ? `vehiculo_id:${g.vehiculo_id}` : "");

// Cambiar a quién pertenece un plan ya guardado (y la asociación del gasto de su entrada, si lo tiene).
export const CambiarPersona = ({ plan, onClose }) => {
  const { fetchAll, gastos = [], viviendas = [], vehiculos = [], pets = [], guardarGasto } = useData();
  const gasto = plan.documento_id ? gastos.find((g) => g.documento_id === plan.documento_id) : null;
  const [p, setP] = useState(plan.family_member_id || null);
  const [parts, setParts] = useState(plan.participantes || []);
  const [asoc, setAsoc] = useState(asocDe(gasto));
  const [ocupado, setOcupado] = useState(false);
  const opciones = [
    ...viviendas.map((v) => [`vivienda_id:${v.id}`, `Vivienda · ${v.alias}`]),
    ...vehiculos.map((v) => [`vehiculo_id:${v.id}`, `Vehículo · ${v.alias}`]),
    ...pets.map((m) => [`pet_id:${m.id}`, `Mascota · ${m.name}`]),
  ];
  const guardar = async () => {
    setOcupado(true);
    try {
      await api.put(`/ocio/planes/${plan.id}/personas`, { family_member_id: p, participantes: parts });
      if (gasto) {
        const [campo, id] = asoc.split(":");
        await guardarGasto(gasto.id, { ...camposGasto(gasto), vivienda_id: null, vehiculo_id: null, pet_id: null, ...(campo ? { [campo]: id } : {}), family_member_id: p });
      }
      await Promise.all([recargarPlanes(), fetchAll()]);
      toast.success("Plan actualizado");
      onClose();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "No se pudo guardar."); setOcupado(false); }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center" data-testid="ocio-cambiar-persona">
      <div className="absolute inset-0 bg-[#1C2421]/40" onClick={onClose} />
      <div className="relative bg-[#FAF8F4] w-full sm:max-w-md rounded-t-3xl sm:rounded-3xl p-6 space-y-4 max-h-[90vh] overflow-y-auto">
        <h2 className="font-heading text-xl font-bold text-[#1C2421]">{plan.nombre}</h2>
        <PersonaPlan principal={p} participantes={parts} onChange={(a, b) => { setP(a); setParts(b); }} />
        {gasto && opciones.length > 0 && (
          <label className="block">
            <span className="text-sm font-semibold text-[#4A5550]">Asociar el gasto de esta entrada a</span>
            <select data-testid="ocio-cambiar-asociado" value={asoc} onChange={(e) => setAsoc(e.target.value)}
              className="mt-1.5 w-full min-h-[52px] rounded-xl border border-[#E5DFD5] bg-white px-4 text-base text-[#1C2421]">
              <option value="">No asociar</option>
              {opciones.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          </label>
        )}
        <button data-testid="ocio-cambiar-persona-guardar" disabled={ocupado} onClick={guardar} className="w-full min-h-[52px] rounded-xl bg-[#3A6B56] text-white font-semibold text-lg disabled:opacity-50">{ocupado ? "Guardando…" : "Guardar"}</button>
        <button data-testid="ocio-cambiar-persona-cancelar" onClick={onClose} className="w-full min-h-[44px] text-[#4A5550] font-semibold">Cancelar</button>
      </div>
    </div>
  );
};
